<template>
  <div class="content">
    <div class="container-fluid h-100">
      <card-item>
        <div class="row">
          <div class="col-12">
            <label class="label" for="vehiculo">Facturación</label>
          </div>
        </div>
        <div class="row h-100" v-if="hayEmpresas || disabled">
          <form
            v-promise-btn="{ action: 'submit' }"
            @submit.prevent="submit"
            class="container"
          >
            <EmpresasFacturacionForm
              @hayEmpresas="hayEmpresasEvent"
              :disabled="disabled"
            />

            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-end">
                  <button
                    class="btn btn-primary"
                    type="submit"
                    :disabled="disabled"
                    :style="
                      disabled ? { opacity: '0.7', cursor: 'not-allowed' } : {}
                    "
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="row" v-else>
          <div class="col-12 text-center">El cliente no tiene empresas</div>
        </div>
      </card-item>
    </div>
  </div>
</template>
<script>
import EmpresasFacturacionForm from "../Modificar/EmpresasFacturacionForm.vue";
import { get, isNil } from "lodash-es";
import axios from "axios";

export default {
  name: "FacturacionForm",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    idContrato: null,
    hayEmpresas: true,
  }),
  components: { EmpresasFacturacionForm },
  methods: {
    hayEmpresasEvent(hayEmpresas) {
      this.hayEmpresas = hayEmpresas;
    },
    async submit() {
      const idContrato = this.$route.params.id_contrato;

      if (isNil(get(this.empresaPropia, "id_empresas_propias", null))) {
        this.$msgBoxOk("Por favor, elija una empresa propia");
        return;
      }

      const resp = await axios.post("/execute", {
        method: "CLI.ModificarFacturacion",
        parameters: [
          { name: "id_contrato", value: idContrato },
          {
            name: "id_empresa_propia",
            value:
              get(this.empresaPropia, "id_empresas_propias", null) === 0
                ? null
                : get(this.empresaPropia, "id_empresas_propias", null),
          },
          { name: "id_empresa", value: get(this.empresa, "id_empresa", null) },
          {
            name: "subfactura",
            value: get(this.subfactura, "subfactura", null),
          },
        ],
      });
      if (resp.data.ok) {
        this.$msgBoxOk(
          `Se han guardado los siguientes datos: - Empresas propias: ${get(
            this.empresaPropia,
            "RazonSocial",
            "Sin Factura",
          )} , -Empresa del cliente : ${get(
            this.empresa,
            "RazonSocial",
            "",
          )} y Subfacturas: ${get(
            this.subfactura,
            "subfactura",
            "-",
          )}  con éxito`,
        );
      }
      return resp.data;
    },
  },
  computed: {
    empresaPropia: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.empresaPropia;
      },
    },
    empresa: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.empresa;
      },
    },
    subfactura: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.subfactura;
      },
    },
  },
};
</script>
<style scoped>
button:disabled {
  opacity: 0.7 !important;
  color: #007bff !important;
  background-color: #f8f9fa !important;
  border-color: #007bff !important;
  cursor: not-allowed !important;
}
</style>
